import { isBrowser } from '../functions/is-browser';
import { isFromTrustedHost } from '../functions/is-from-trusted-host';
import { setupBrowserForEditing } from '../scripts/init-editing';
import { logger } from './logger';
export const createEditorListener = ({ model, trustedHosts, callbacks }) => {
    return (event) => {
        if (!isFromTrustedHost(trustedHosts, event)) {
            return;
        }
        const { data } = event;
        if (data) {
            switch (data.type) {
                case 'builder.configureSdk':
                    {
                        callbacks.configureSdk(data.data);
                        break;
                    }
                case 'builder.triggerAnimation':
                    {
                        callbacks.animation(data.data);
                        break;
                    }
                case 'builder.contentUpdate':
                    {
                        const messageContent = data.data;
                        const key = messageContent.key || messageContent.alias || messageContent.entry || messageContent.modelName;
                        const contentData = messageContent.data;
                        if (key === model) {
                            callbacks.contentUpdate(contentData);
                        }
                        break;
                    }
            }
        }
    };
};
/**
 * Subscribes to the Builder editor and listens to `content` updates of a certain `model`.
 * Sends the updated `content` to the `callback` function.
 */
export const subscribeToEditor = (model, callback, options) => {
    if (!isBrowser) {
        logger.warn('`subscribeToEditor` only works in the browser. It currently seems to be running on the server.');
        return () => { };
    }
    setupBrowserForEditing();
    const listener = createEditorListener({
        callbacks: {
            contentUpdate: callback,
            animation: () => { },
            configureSdk: () => { }
        },
        model,
        trustedHosts: options?.trustedHosts
    });
    window.addEventListener('message', listener);
    return () => {
        window.removeEventListener('message', listener);
    };
};
